'use client'
import { Product } from '@/features/product/model/product.model'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { ProductList } from '../productList'
import { ROUTES } from '@/core/constants/routes'

type Props = {
  products: Product[]
}
export function RecentlyAdded({ products }: Props) {
  const t = useTranslations()

  return (
    <article className='my-10'>
      <div className='mb-1 flex items-center justify-between px-5'>
        <h2 className='mb-3 text-xl font-semibold'>
          {t('products.recentlyAdded')}
        </h2>
        <Link
          href={ROUTES.search}
          className='text-creamed-cron mb-3 text-sm font-bold'
        >
          {t('actions.viewAll')}
        </Link>
      </div>
      <section className='mx-auto'>
        <ProductList products={products} />
      </section>
    </article>
  )
}
